import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import { loadTasProgramInstanceHistory } from 'tio-data/requests/tas-program-instance';
import type { TasProgramInstanceExtension as TASProgramInstance } from 'tio-data/data/resources/tas-program-instance.ext';
import type { Store as StoreService } from '@warp-drive/core';

interface Params {
  tas_program_instance_id: string;
}

export default class AuthenticatedAdminTasProgramsRoute extends Route {
  @service declare store: StoreService;

  includes = [
    'tas-applications.tas-courses',
    'tas-applications.comments.person',
    'tas-applications.tas-assets.attachments',
    'tas-applications.tags',
    'tas-program-template',
    'tas-program-template.tas-field-options',
    // The partner-messaging flag hangs off the TEMPLATE's company, which every
    // other surface reading it loads. Without it the flag is always false here,
    // so the comments drawer's employee tab could never appear.
    'tas-program-template.company.company-setting',
    'employee.person',
    'employee.company',
    'employee.company.company-setting',
    'employee.company.comments',
    'employee.tas-participant',
    'tas-assets.attachments',
    // `.person` so the recent-comment card and the drawer can render the author's
    // first/last name rather than falling back to the flat `commentor` string.
    'comments.person',
  ];

  // @ts-expect-error - Route model signature mismatch with Ember Route types
  async model(params: Params): Promise<TASProgramInstance> {
    const { content } = (await this.store.request(
      findRecord<TASProgramInstance>('tas-program-instance', params.tas_program_instance_id, {
        include: this.includes,
        reload: true,
      })
    )) as { content: { data: TASProgramInstance } };
    const instance = content.data;

    await loadTasProgramInstanceHistory(this.store, instance);

    return instance;
  }
}
